import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MorningOvertimeHeadSetting } from '../../models/morning-overtime-readiness.model';

@Component({
  selector: 'app-morning-overtime-head-action',
  templateUrl: './morning-overtime-head-action.component.html',
  styleUrls: ['./morning-overtime-head-action.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MorningOvertimeHeadActionComponent {
  @Input() public setting: MorningOvertimeHeadSetting;
  @Input() public isLoading: boolean;
  @Input() public isSubmitting: boolean;
  @Input() public errorKey: string;
  @Output() public settingChangeRequested: EventEmitter<boolean>;

  constructor() {
    this.settingChangeRequested = new EventEmitter<boolean>();
  }

  public get canShowToggle(): boolean {
    return !!this.setting && this.setting.canManage && !this.hasError;
  }

  public get canClickToggle(): boolean {
    return this.canShowToggle && !this.isSubmitting;
  }

  public get actionKey(): string {
    if (this.isSubmitting) {
      return 'MORNING_OVERTIME_HEAD_ACTION_SAVING';
    }
    if (this.setting && this.setting.enabled) {
      return 'MORNING_OVERTIME_HEAD_ACTION_DISABLE';
    }
    return 'MORNING_OVERTIME_HEAD_ACTION_ENABLE';
  }

  public get statusKey(): string {
    if (this.setting && this.setting.enabled) {
      return 'MORNING_OVERTIME_HEAD_SETTING_ENABLED';
    }
    return 'MORNING_OVERTIME_HEAD_SETTING_DISABLED';
  }

  public get hasError(): boolean {
    return !!this.errorKey;
  }

  public onToggleClick(): void {
    if (!this.canClickToggle || !this.setting) {
      return;
    }
    this.settingChangeRequested.emit(!this.setting.enabled);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/morning-overtime-readiness/components/morning-overtime-head-action/morning-overtime-head-action.component.ts